import { SettingsItem } from '@/model/SettingsItem'
import { SettingsResponse } from '@/types/service-response'
import store from '@/store'
import { SETTINGS_REPLACE } from '@/store/mutation-types'
import { SETTINGS_ALL } from '@/store/getter-types'

const parseTypeMap = {
  'boolean': parseBooleanValue
}

export function createModelFromResponse (data: SettingsResponse): SettingsItem[] {
  return data.map((i) => {
    const value = parseValue(i.value, i.type)

    return new SettingsItem(i.key, value, i.type)
  })
}

export function replace (payload: SettingsItem[]): void {
  store.commit(SETTINGS_REPLACE, payload)
}

export function getSetting (key: string): SettingsItem | null {
  const settings = store.getters[SETTINGS_ALL]

  return settings.find((i: SettingsItem) => i.key === key)
}

export function setSetting (key: string, value: boolean) {
  const settingItem = getSetting(key)

  const newItem = new SettingsItem(key, value, settingItem!.type)

  const settings: SettingsItem[] = store.getters[SETTINGS_ALL]
  const idx = settings.findIndex((i) => i.key === key)

  settings.splice(idx, 1, newItem)
}

function parseValue (value: string, type: string): boolean | number | string {
  const t = type.toLowerCase()

  //@ts-ignore
  if ((parseTypeMap[t] as any)) {
    //@ts-ignore
    return parseTypeMap[t](value)
  }

  return value
}

function parseBooleanValue (value: string): boolean {
  return value.toLowerCase().trim() === 'true'
}
